import { Selection } from './../../../3rdparty/walkontable/src';
/**
 * @return {Selection}
 */

function createHighlight(_ref) {
  var activeHeaderClassName = _ref.activeHeaderClassName;
  var s = new Selection({
    highlightHeaderClassName: activeHeaderClassName
  });
  return s;
}

export default createHighlight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/es/selection/highlight/types/activeHeader.js
// module id = 839
// module chunks = 0